import type { ActionsOf } from 'store/types';

import type { PartFileCadEntities } from './types';

export const types = {
  FETCH_PART_FILE_CAD_DATA_ERROR:
    'common/viewer/cadViewer/partFileCadData/FETCH_PART_FILE_CAD_DATA_ERROR',
  FETCH_PART_FILE_CAD_DATA_INIT:
    'common/viewer/cadViewer/partFileCadData/FETCH_PART_FILE_CAD_DATA_INIT',
  FETCH_PART_FILE_CAD_DATA_SUCCESS:
    'common/viewer/cadViewer/partFileCadData/FETCH_PART_FILE_CAD_DATA_SUCCESS',
  PART_FILE_BULK_CAD_DATA_RECEIVE:
    'common/viewer/cadViewer/partFileCadData/PART_FILE_BULK_CAD_DATA_RECEIVE',
} as const;

export type PartFileUuidPayload = {
  partFileUuid: string;
};

export type FetchPartFileCadDataSuccessPayload = {
  entities: PartFileCadEntities;
  partFileUuid: string;
  rootViewerBodyViewerId: string;
};

export type PartFileBulkCadDataReceivePayload = {
  partFileUuids: string[];
};

export const fetchPartFileCadStructure = {
  error: ({ partFileUuid }: PartFileUuidPayload) => ({
    type: types.FETCH_PART_FILE_CAD_DATA_ERROR,
    payload: { partFileUuid },
  }),
  init: ({ partFileUuid }: PartFileUuidPayload) => ({
    type: types.FETCH_PART_FILE_CAD_DATA_INIT,
    payload: { partFileUuid },
  }),
  success: ({
    entities,
    partFileUuid,
    rootViewerBodyViewerId,
  }: FetchPartFileCadDataSuccessPayload) => ({
    type: types.FETCH_PART_FILE_CAD_DATA_SUCCESS,
    payload: {
      entities,
      partFileUuid,
      rootViewerBodyViewerId,
    },
  }),
};

export const partFileBulkCadData = {
  receive: ({ partFileUuids }: PartFileBulkCadDataReceivePayload) => ({
    type: types.PART_FILE_BULK_CAD_DATA_RECEIVE,
    payload: { partFileUuids },
  }),
};

export type PartFileCadDataAction = ActionsOf<{
  fetchPartFileCadStructure: typeof fetchPartFileCadStructure;
  partFileBulkCadData: typeof partFileBulkCadData;
}>;
